import React, { useEffect, useState } from "react";
import Snackbar from '@mui/material/Snackbar';

import '../../assets/css/common.css';
import '../../assets/css/sidemenu.css';
import '../../assets/css/timesheet.css';

import NavBar from "../../components/nav-bar";
import SideBar from "../../components/sidebar";

import EditDialog from './edit-dialog';

function FarmConfiguration() {
    const [configuration, setConfiguration] = useState({});
    const [showEditDialog, setShowEditDialog] = React.useState(false);
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState("");

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        fetch(`${process.env.REACT_APP_API_URL}/farm_configurations`)
            .then(response => response.json())
            .then(json => setConfiguration(json))
            .catch(error => console.error(error));
    };

    const handleEditOpen = () => {
        setShowEditDialog(true);
    };

    const handleEditClose = () => {
        setShowEditDialog(false);
    };

    const handleEditSave = (data) => {
        setShowEditDialog(false);
        if (data.loading_time !== configuration.loading_time || data.unloading_time !== configuration.unloading_time || data.wait_time !== configuration.wait_time || data.changeover_time !== configuration.changeover_time) {
            fetch(`${process.env.REACT_APP_API_URL}/farm_configurations`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(json => {
                    fetchData();
                    setShowSnackbar(true);
                    setSnackbarMessage("Data updated successfully.");
                })
                .catch(error => {
                    setShowSnackbar(true);
                    setSnackbarMessage("Error while updating data.");
                });
        } else {
            setShowSnackbar(true);
            setSnackbarMessage("No changes found.");
        }
    }

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <NavBar title={"Configuration"} />
                    <div className="container-fluid">
                        <div className="row">
                            <SideBar />

                            <div className="home-section">
                                <div className="col-lg-12 mb-2 pb-2" id="logContainer">
                                    <div className="row m-0 justify-content-between align-items-center">
                                        <div className="card-header p-0" style={{ borderBottom: "none" }}>
                                            {/* <ul className="nav nav-tabs justify-content-start common-view-tabs" role="tablist">
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link active common-view-link" data-status-id="0"
                                                        id="nav-Current-tab" data-toggle="tab" href="#nav-Current"
                                                        role="tab" aria-controls="nav-Current"
                                                        aria-selected="true">Scheduler</a>
                                                </li>
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link common-view-link" data-status-id="1"
                                                        id="nav-History-tab" data-toggle="tab" href="#nav-History"
                                                        role="tab" aria-controls="nav-History"
                                                        aria-selected="true">History</a>
                                                </li>
                                            </ul> */}
                                        </div>
                                        <div className="col-md-6 top-right d-flex justify-content-end align-items-end"
                                            style={{ gap: "10px" }}>
                                            {/* <div className="container-fluid">
                                                <input className="Enquiry-form-control" type="search" id="searchInput"
                                                    placeholder="Search by Process" />
                                            </div> */}
                                            {/* <div className="d-flex" style={{ gap: "10px" }}>
                                                <div>
                                                    <a role="button" className="c-black" href="/temp/Production Schedule.xlsx"
                                                        title="Download Report">
                                                        <i className="f-24 i-btn cursor-pointer ti ti-download"></i>
                                                    </a>
                                                </div>
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Filter" onClick="openSideFilterPanel()">
                                                    <i id="filter-icon" className="f-24 i-btn cursor-pointer ti ti-filter"></i>
                                                </a>
                                            </div> */}
                                            <div id="plan-insert-record">
                                                <i className="f-24 i-btn cursor-pointer ti ti-edit" onClick={handleEditOpen}></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-content mt-1" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-Current" role="tabpanel"
                                            aria-labelledby="nav-Current-tab">
                                            <div id="list_content" className="table-responsive">
                                                <table className="table-list table-hover schedule-table" style={{ width: "100%" }}
                                                    id="plan-schedule-table">
                                                    <thead>
                                                        <tr className="table-list-header-row" style={{ color: "#ffffff" }}>
                                                            <th>Configuration</th>
                                                            <th>Time (Hrs)</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="table-list-body">
                                                        <tr className="table-list-body-row collapse plan-schedule-row show">
                                                            <td data-type="text" name="name">Loading Time</td>
                                                            <td data-type="text" name="vehicle_type">{configuration.loading_time}</td>
                                                        </tr>
                                                        <tr className="table-list-body-row collapse plan-schedule-row show">
                                                            <td data-type="text" name="name">Unloading Time</td>
                                                            <td data-type="text" name="vehicle_type">{configuration.unloading_time}</td>
                                                        </tr>
                                                        <tr className="table-list-body-row collapse plan-schedule-row show">
                                                            <td data-type="text" name="name">Wait Time</td>
                                                            <td data-type="text" name="capacity">{configuration.wait_time}</td>
                                                        </tr>
                                                        <tr className="table-list-body-row collapse plan-schedule-row show">
                                                            <td data-type="text" name="name">Changeover Time</td>
                                                            <td data-type="text" name="rate">{configuration.changeover_time}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <EditDialog
                        selectedValue={configuration}
                        open={showEditDialog}
                        onClose={handleEditClose}
                        onSave={handleEditSave}
                    />
                    <Snackbar
                        open={showSnackbar}
                        autoHideDuration={2000}
                        onClose={() => setShowSnackbar(false)}
                        message={snackbarMessage}
                    />
                </div>
            </main>
        </div>
    );
}
export default FarmConfiguration;